import { useEffect, useRef, useState } from 'react'

import ChevronDownIcon from '../../assets/icons/chevron-down.svg?react'
import { COUNTRY_DIAL_CODES } from './countryDialCodes'

interface CountryCodeSelectProps {
  value: string
  onChange: (dialCode: string) => void
  disabled?: boolean
}

export const CountryCodeSelect: React.FC<CountryCodeSelectProps> = ({
  value,
  onChange,
  disabled
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen])

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        disabled={disabled}
        className="h-10 flex items-center gap-1.5 px-3 rounded-lg border border-neutralBlack-50 bg-neutralBlack-50 text-sm text-neutralBlack-800 cursor-pointer hover:border-neutralBlack-300 disabled:opacity-50 disabled:pointer-events-none whitespace-nowrap"
      >
        {value}
        <ChevronDownIcon className="size-3 text-neutralBlack-500" />
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-1.5 w-48 max-h-64 overflow-y-auto bg-white border border-neutralBlack-200 rounded-xl shadow-lg py-1.5">
          {COUNTRY_DIAL_CODES.map((country) => (
            <button
              key={country.dialCode + country.name}
              type="button"
              onClick={() => {
                onChange(country.dialCode)
                setIsOpen(false)
              }}
              className="w-full flex items-center justify-between gap-2 px-3 py-2 text-sm text-left hover:bg-neutralBlack-50 cursor-pointer"
            >
              <span className="text-neutralBlack-800">{country.name}</span>
              <span className="text-neutralBlack-400">{country.dialCode}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
